import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const textDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'textTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the TextTestkit unidriver testkit instead.',
  );

  return {
    exists: () => !!element,
    getTagName: () => element.tagName.toLowerCase(),
    getText: () => element.innerHTML,
    getSize: () => element.getAttribute('data-size'),
    getSkin: () => element.getAttribute('data-skin'),
    getWeight: () => element.getAttribute('data-weight'),
    getId: () => element.getAttribute('id'),
    isLight: () => element.getAttribute('data-light') === 'true',
    isSecondary: () => element.getAttribute('data-secondary') === 'true',
    isMasked: () => element.getAttribute('data-mask') === 'true',
    isWidows: () => element.getAttribute('data-widows') === 'true',
  };
};

export { textDriverFactory };
